import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import React, { useState, useEffect } from 'react';
import HLSChat from 'components/HlsChat';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import { Container, IconButton } from '@material-ui/core';
import useStyles from './styles';
import { useSelector } from 'react-redux';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Container style={{ padding: '0px' }}>
          <Box>{children}</Box>
        </Container>
      )}
    </div>
  );
}

const HlsSideMenu = ({ session, isOpen, setShowNotificationChat }) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [data, setData] = useState({});
  const state = useSelector((state) => state.participantsListReducer);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const userData = sessionStorage.getItem('userData');
    if (userData !== 'undefined') {
      const data = JSON.parse(userData);
      setData(data);
      console.log('sessionData', data);
    }
  }, []);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <div
      className={`${classes.chatMain} ${isOpen && classes.chatMainOpen}`}
      style={{ zIndex: '1' }}
    >
      <AppBar position='static'>
        <div className={classes.chatTabWrapper}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='More option tabs'
          >
            <Tab label='Private Chat' {...a11yProps(0)} />
          </Tabs>
        </div>
      </AppBar>

      <TabPanel value={value} index={0}>
        <HLSChat
          session={session}
          setShowNotificationChat={setShowNotificationChat}
          isOpen={isOpen}
        />
      </TabPanel>
    </div>
  );
};

export default HlsSideMenu;
